import apiClient from "../apiClient";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const CurrenciesUpdate = () => {
    const [currency, setCurrency] = useState({
        Description: "",
        IsDefault: 0,
        ExchangeRateToDefault: "1.000000",
        });

    const [error, setError] = useState(false)

    const navigate = useNavigate();
    const location = useLocation();

    const currencyId = location.pathname.split("/")[2]

    useEffect(() => {
        const fetchCurrency = async () => {
            try {
                const res = await apiClient.get("/currencies");
                const rows = Array.isArray(res.data) ? res.data : [];
                const selected = rows.find((item) => String(item.CurrencyID || item.CurrencyId) === String(currencyId));
                if (!selected) {
                    setError(true);
                    return;
                }
                setCurrency({
                    Description: selected.Description || "",
                    IsDefault: Number(selected.IsDefault) ? 1 : 0,
                    ExchangeRateToDefault: selected.ExchangeRateToDefault != null ? String(selected.ExchangeRateToDefault) : "1.000000",
                });
            } catch (err) {
                setError(true);
            }
        };
        fetchCurrency();
    }, [currencyId]);

    const handleChange = (e) => {
        const value = e.target.type === "checkbox" ? (e.target.checked ? 1 : 0) : e.target.value;
        setCurrency((prev) => {
            const next = { ...prev, [e.target.name]: value };
            if (e.target.name === "IsDefault" && value) {
                next.ExchangeRateToDefault = "1.000000";
            }
            return next;
        });
        }

    const handleClick = async(e) => {
        e.preventDefault();
        if (!currency.Description?.trim()) return setError(true);
        try {
            await apiClient.put("/currencies/" + currencyId, currency);
            navigate("/Currencies");
        } catch (err) {
            console.log(err);
            setError(true)
        }
     };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Update Currency</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Currencies">Currencies</Link> / Update</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="currency-description">Currency Description</label>
                    <input
                        id="currency-description"
                        type="text"
                        placeholder="Currency Description"
                        name="Description"
                        value={currency.Description}
                        onChange={handleChange}
                    />
                    <label htmlFor="currency-is-default">Default Currency</label>
                    <input
                        id="currency-is-default"
                        type="checkbox"
                        name="IsDefault"
                        checked={Boolean(currency.IsDefault)}
                        onChange={handleChange}
                    />
                    <label htmlFor="currency-exchange-rate">Exchange Rate To Default Currency</label>
                    <input
                        id="currency-exchange-rate"
                        type="number"
                        step="0.000001"
                        min="0.000001"
                        name="ExchangeRateToDefault"
                        value={currency.ExchangeRateToDefault}
                        onChange={handleChange}
                        disabled={Boolean(currency.IsDefault)}
                    />
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Update Currency</button>
                        <Link className="btn-link" to="/Currencies">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not update currency. Check input and try again.</p>}
                </div>
            </section>
        </div>
         );
    };

export default CurrenciesUpdate;
